import { useEffect, useState } from 'react';

// useLocalFlag is a React hook that returns a `[value, set]` pair
// backed by a string key in window.localStorage. The value is
// coerced to a boolean ("true"/"false"). Reads at mount time only;
// subsequent updates within the same tab go through `set`.
// SSR-safe: returns the supplied default on the server.
export function useLocalFlag(
  key: string,
  defaultValue: boolean,
): [boolean, (next: boolean) => void] {
  const [value, setValue] = useState<boolean>(() => {
    if (typeof window === 'undefined') return defaultValue;
    try {
      const raw = window.localStorage.getItem(key);
      if (raw === null) return defaultValue;
      return raw === 'true';
    } catch {
      return defaultValue;
    }
  });
  useEffect(() => {
    try {
      window.localStorage.setItem(key, String(value));
    } catch {
      // ignored; quota/private-mode failures are non-fatal
    }
  }, [key, value]);
  return [value, setValue];
}
